/* globals Store */

import tapApi from '@/utils/api/tap-api'
import {
  sendErrorNotice,
  sendSuccessNotice,
  closeNotice
} from '@/utils/store-util.js'
const state = {
  busyDates: [],
  busyMap: {},
  loading: false
}

const actions = {
  logout ({ commit }) {
    commit('logout')
  },
  getMonthData ({ commit }, {month, cb}) {
    commit('setLoading', true)
    if (Store.state.calendar.busyMap[month] === undefined) {
      tapApi.getData('user/calendar/' + month)
      .then(res => {
        if (res.data.status === 'SUCCESS') {
          commit('setBusyMapMonth', {month, list: res.data.data})
          commit('setBusyDates', month)
          if (cb) cb(month, res.data.data.splice(0))
        } else {
          Store.dispatch('project/dealUnsuccessResponse', res.data)
        }
      })
      .catch(err => {
        console.log(err)
        sendErrorNotice(commit, 'Operation failed! Please try again later. ')
        closeNotice(commit, 20000)
      })
      .finally(() => {
        commit('setLoading', false)
      })
    } else {
      commit('setBusyDates', month)
      if (cb) cb(month, Store.state.calendar.busyDates.splice(0))
    }
  },
  updateCalendarDates ({commit}, {updateDates, currentMonth}) {
    commit('setLoading', true)
    tapApi.postData('user/calendar', updateDates)
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        commit('setBusyMap', {updateDates, currentMonth})
        sendSuccessNotice(null, 'Calendar dates updated')
        closeNotice(null, 1500)
      }
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(null, 'Operation failed! Please try again later')
      closeNotice(null, 20000)
    })
    .finally(() => {
      commit('setLoading', false)
    })
  }
}

const mutations = {
  setLoading (state, value) {
    state.loading = value
  },
  setBusyDates (state, month) {
    state.busyDates = state.busyMap[month]
  },
  setBusyMapMonth (state, {month, list}) {
    state.busyMap[month] = list
  },
  setBusyMap (state, {updateDates, currentMonth}) {
    state.busyMap = updateDates
    state.busyDates = updateDates[currentMonth]
  },
  logout (state) {
    state.busyMap = {}
    state.busyDates = []
    state.loading = false
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/calendar.js